export default __webpack_public_path__ + "static/media/tick.aec55355.svg";